export interface File {
  id: string;
  name: string;
  timeLastAccess: number;
  size: string;
  fileType: string;
}
